<template>
	<div>
		<nav class="navbar bg-main">
			<div class="btn btn-back" @click="back" v-if="navBackLink">
				<div class="icon icon-left-open-mini"></div>
			</div>
			<div class="btn btn-menu-toggle" v-else @click="opened = !opened">
				<div class="icon-menu-bars">
					<div class="b"></div>
					<div class="b"></div>
					<div class="b"></div>
				</div>
			</div>
			<img
				v-if="!navbarTitle && loggedUser && loggedUser.account && loggedUser.account.logo"
				:src="loggedUser.account.logo.urlThumb"
				class="logo"
			/>

			<div v-if="navbarTitle" class="pageTitle">{{ navbarTitle }}</div>
		</nav>
		<Sidebar :opened="opened" />
	</div>
</template>

<script>
import Sidebar from "./Sidebar"
import { mapGetters } from "vuex"

export default {
	name: "Navbar",
	components: {
		Sidebar
	},
	props: ["navbarTitle", "navBackLink"],
	data() {
		return {
			opened: false
		}
	},
	computed: {
		...mapGetters(["loggedUser"])
	},

	methods: {
		back() {
			if (this.navBackLink != "") {
				this.$router.push(this.navBackLink)
			}
			this.$emit("back")
		}
	}
}
</script>
<style scoped lang="scss">
.navbar {
	padding: 0px 8px;
	width: 100%;
	height: 58px;
	top: 0px;
	color: #fff;
	z-index: 150;
	position: fixed !important;
	display: flex;
	align-items: center;
	justify-content: space-between;

	.btn-menu-toggle {
		display: flex;
		align-items: center;

		// .icon {
		// 	display: flex;
		// 	align-items: center;
		// 	justify-content: center;
		// 	font-size: 24px;
		// 	color: #fff;
		// }
		.b {
			width: 18px;
			margin: 4px 0px;
			height: 2px;
			background-color: #fff;
			display: block;
			-webkit-transition: all 0.2s ease-in-out;
			-moz-transition: all 0.2s ease-in-out;
			-o-transition: all 0.2s ease-in-out;
			transition: all 0.2s ease-in-out;

			&:first-child {
				width: 15px;
			}
			&:not(:first-child):not(:last-child) {
				width: 13px;
			}
		}
		.icon-menu-bars:hover .b {
			width: 18px !important;
		}
	}
}

.btn-back {
	display: flex;
	align-items: center;
	.icon {
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 24px;
		color: #fff;
	}
}

.navbar .pageTitle {
	font-size: 16px;
	font-weight: 600;
}

.nav-spacer {
	width: 100%;
	height: 58px;
}
.navbar .logo {
	max-width: 90px;
	filter: brightness(0) invert(1);
}
</style>
